import React, { FC } from 'react';
import { InputSliderProps } from './types';
import { useSlide } from './useSlide';
import { calculatePercentage, getHandlerSize } from './utils';
import Track from './Track';
import Handler from './Handler';
import Marks from './Marks';
import Dots from './Dots';
import { useSliderStyles } from './styles';
import { cx } from '../customEmotion';

export { InputSliderProps };

const InputSlider: FC<InputSliderProps> = ({
	className,
	vertical,
	size,
	value,
	min,
	max,
	step,
	dots,
	marks,
	onBeforeChange,
	onChange,
	onAfterChange,
	onClickChange,
}) => {
	const { sliderRef, handlerRef, onSliderClick, onSlideStart } = useSlide({
		value,
		min,
		max,
		step,
		vertical,
		onBeforeChange,
		onChange,
		onAfterChange,
		onClickChange,
	});
	const percentage = calculatePercentage(value, min!, max!);
	const handlerSize = getHandlerSize(size!);
	const styles = useSliderStyles([vertical, size, handlerSize, !!marks]);

	return (
		<div
			className={className ? cx(styles.slider, className) : styles.slider}
			ref={sliderRef}
			onClick={onSliderClick}
		>
			<div
				className={styles.rail}
			/>
			<Track
				className={styles.track}
				vertical={vertical!}
				percentage={percentage}
			/>
			{marks || dots ? (
				<Dots
					vertical={vertical!}
					size={size!}
					marks={marks}
					dots={dots!}
					step={step!}
					lowerBound={min!}
					upperBound={value}
					min={min!}
					max={max!}
				/>
			) : null}
			<Handler
				ref={handlerRef}
				className={styles.handler}
				vertical={vertical!}
				percentage={percentage}
				onSlideStart={onSlideStart}
			/>
			{marks && (
				<Marks
					vertical={vertical!}
					handlerSize={handlerSize}
					marks={marks}
					lowerBound={min!}
					upperBound={value}
					range={max! - min!}
					onChange={onClickChange}
				/>
			)}
		</div>
	);
};

InputSlider.defaultProps = {
	vertical: false,
	size: 8,
	min: 0,
	max: 100,
	step: 1,
	dots: false,
};

export default InputSlider;
